

















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";
import { Getter } from "vuex-class";
import ThousandNumberInput from "@/components/forms/inputs/ThousandNumberInput.vue";
import BundleRepository from "@/repositories/socle/BundleRepository";
import moment from "moment";
import Http from "front-component/Http";
import EventBus from "front-component/EventBus";
import {Bundle} from "@/modules/socle/Bundle";
import {BundleLog} from "@/modules/socle/BundleLog";
import {MessageBoxInputData} from "element-ui/types/message-box";
import {User} from "front-component/modules/User";
import {SOCLE_APPROVAL_STATUS_APPROVED, SOCLE_APPROVAL_STATUS_PENDING} from "@/Constants";
import {SocleClient} from "@/modules/Socle";
import * as Constants from "@/Constants";

const components = {
    ThousandNumberInput,
};

// Bout de code généré automatiquement par PhpStorm, je pense que c'est la première déclaration de ce genre, un avis ?
@Component({
    methods: {
        SOCLE_APPROVAL_STATUS_PENDING() {
            return SOCLE_APPROVAL_STATUS_PENDING;
        },
        SOCLE_APPROVAL_STATUS_APPROVED() {
            return SOCLE_APPROVAL_STATUS_APPROVED;
        },
    },
    components})
export default class CampaignLightForm extends Vue {
    public bundle: any | null = false;
    public loading: boolean = false;
    public budgets: any[] = [];
    public imgSrc: string = "";
    public budgetUuid: string = "";
    public selectedBudget: string | null = null;
    public budgetSelectReason: string = "";
    public commentSelectReason: string = "";
    public recommendedBudget: string | null = null;
    public lowerRecommendedBudget: number | null = null;
    public lastLog: BundleLog | null = null;
    public logMessageType: string | null = null;
    public drawerDisplayed: boolean = false;
    public bypassValidation: boolean = false;

    @Prop(String) public bundleUuid!: string | null;
    @Prop(Boolean) public visible!: boolean;
    @Prop() public configSocleData!: SocleClient;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getCurrentUser") public currentUser!: User|null;

    @Watch("bundleUuid") private changeBundle() {
        this.fetchData();
    }

    @Watch("ownerUuid") private changeOwner() {
        this.fetchData();
    }

    public mounted() {
        if (!this.bundleUuid) {
            return;
        }
        this.fetchData();
    }

    private fetchData() {
        this.bypassValidation = false;
        return new Promise((resolve) => {
            if (!this.ownerUuid || !this.bundleUuid)  {
                return;
            }
            this.loading = true;
            const params = {
                filters: {
                    uuid: this.bundleUuid,
                },
                fields: [
                    "uuid",
                    "approvalDeadline",
                    "approvalStatus",
                    "approvedAt",
                    "noSelectedBudgetReason",
                    "campaign.uuid",
                    "campaign.label",
                    "campaign.startDate",
                    "campaign.endDate",
                    "campaign.code",
                    "campaign.externalCode",
                    "campaign.pictureBase64",
                    "campaign.formattedWeek",
                    "logs.performedBy.displayName",
                    "logs.loggedAt",
                    "logs.message",
                    "logs.metadata",
                    "hierarchyOwner.uuid",
                    "hierarchyOwner.fullName",
                    "hierarchyOwner.dependentStatus",
                    "hierarchyOwner.clientCode1",
                    "budgets.uuid",
                    "budgets.defaultBudget",
                    "budgets.label",
                    "budgets.selected",
                    "budgets.totalRecommendedAmount",
                    "budgets.validationDeadline",
                ]
            };
            BundleRepository.get(params)
                .then((data: object[]) => {
                    this.bundle = data[0] as Bundle;
                    this.imgSrc = this.bundle.campaign.pictureBase64;

                    if (this.bundle.logs) {
                        const first = _.first(this.bundle.logs);
                        this.lastLog = first !== undefined ? first as unknown as BundleLog : null;
                    }

                    const firstBudget = _.first(this.bundle.budgets);
                    if (firstBudget) {
                        this.lowerRecommendedBudget = _.get(firstBudget, "totalRecommendedAmount", 0);
                    }

                    const foundSelectedBudget = _.find(this.bundle.budgets, "selected");
                    if (foundSelectedBudget) {
                        this.selectedBudget = foundSelectedBudget.uuid;
                        this.recommendedBudget = _.invoke(
                            this.$options.filters,
                            "price",
                            foundSelectedBudget.totalRecommendedAmount
                        );
                    } else {
                        this.selectedBudget = null;
                    }
                    this.budgetSelectReason = this.bundle.noSelectedBudgetReason;
                    const retirementLog = _.find(this.bundle.logs, (log) => {
                        return log.metadata.commentSelectReason;
                    });
                    this.commentSelectReason = _.get(retirementLog, "metadata.commentSelectReason" , "");

                    this.loading = false;
                    resolve(this.bundle);
                });
        });
    }

    public validateBudget(): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "confirmValidationChoice"))) {
            return ;
        }

        const body = {
            selectedBudgetUuid: this.selectedBudget,
            noBudgetReason: "" !== this.budgetSelectReason ? this.budgetSelectReason : null,
            commentSelectReason: "" !== this.commentSelectReason ? this.commentSelectReason : null,
        };

        Http.callDirect(
            "/socle/" + this.bundleUuid + "/select",
            body,
            (data: any) => {
                this.$emit("update:visible", false);
                this.bundle = null;
                EventBus.$emit("budget-status-updated");
            },
            "error"
        );
    }

    public approveSelect(): void {
        if (!confirm(_.invoke(this.$options.filters, "trans", "confirmValidationChoice"))) {
            return ;
        }
        Http.callDirect(
            "/socle/" + this.bundleUuid + "/approve",
            {},
            (data: any) => {
                this.$emit("update:visible", false);
                this.bundle = null;
                EventBus.$emit("budget-status-updated");
            },
            "error"
        );
    }

    public rejectSelect(): void {
        this.$prompt("", "Commentaire", {
            confirmButtonText: _.invoke(this.$options.filters, "trans", "valid"),
            cancelButtonText: _.invoke(this.$options.filters, "trans", "cancel"),
        }).then((res) => {
            const value = (res as MessageBoxInputData).value;
            Http.callDirect(
                "/socle/" + this.bundleUuid + "/reject",
                {
                    rejectReason: value ? value : ""
                },
                (data: any) => {
                    this.$emit("update:visible", false);
                    this.bundle = null;
                    EventBus.$emit("budget-status-updated");
                },
                "error"
            );
        });
    }

    public cancelChoice(): void {
        const message = _.invoke(this.$options.filters, "trans", "confirmCancelChoice");
        if (confirm(message)) {
            this.bypassValidation = true;
        }
    }

    public editAllowed(): boolean {
        return (this.bundle.approvalStatus === Constants.SOCLE_APPROVAL_STATUS_RECOMMENDED &&
            !this.isApprovalRequestPeriodPassed()) ||
            this.bypassValidation;
    }

    public isApprovalRequestPeriodPassed(): boolean {
        if (_.get(this.currentUser, "socleApprover", false)) {
            return false;
        }
        return moment(this.bundle.approvalDeadline).set("hour", 23).set("minute", 59) < moment();
    }

    public isValidationDeadlinePassed(): boolean {
        const recommendedBudget = _.find(this.bundle.budgets, "defaultBudget");
        const validationDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59);

        return validationDl < moment();
    }

    public getValidationDeadline(): string {
        return _.invoke(
            this.$options.filters,
            "trans",
            "approvalDeadlineMessage",
            "",
            "",
            { deadlineDate: moment(this.bundle.approvalDeadline).format("DD/MM/YYYY") }
        );
    }

    public getDeadlineMessage(): string {
        const recommendedBudget = _.find(this.bundle.budgets, "defaultBudget");
        const validationDl = moment(recommendedBudget.validationDeadline).set("hour", 23).set("minute", 59);
        const approvalRequestDl = moment(this.bundle.approvalDeadline).set("hour", 23).set("minute", 59);

        let deadlineDate = approvalRequestDl.format("DD/MM/YYYY");
        let message = "approvalDeadlineInfo";
        if (_.get(this.currentUser, "socleApprover", false)) {
            deadlineDate = validationDl.format("DD/MM/YYYY");
            message = "validationDeadlineInfo";
        }

        return _.invoke(
            this.$options.filters,
            "trans",
            message,
            "",
            "",
            { deadlineDate }
        );
    }

    public isOperationIsValidated(): boolean {
        return SOCLE_APPROVAL_STATUS_APPROVED === this.bundle.approvalStatus;
    }

    public getLogDate(date: Date): string {
        return _.invoke(
            this.$options.filters,
            "date",
            date
        );
    }

    public getBudgetInfo(uuid: string): string {
        const budget = _.find(this.bundle.budgets, (line) => {
            return line.uuid === uuid;
        });

        return _.get(budget, "label", "");
    }

    public getLogMessage(): string {
        if (!this.lastLog) {
            return "";
        }

        this.logMessageType = this.lastLog.message as string;
        const dateLog = _.invoke(this.$options.filters, "date", this.lastLog ? this.lastLog.loggedAt : new Date());
        const author = this.lastLog.performedBy ? this.lastLog.performedBy.displayName : "défaut";

        switch (this.logMessageType) {
            case "approval_request":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "approval_request_message",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "cancel":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "cancel",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "default_confirm_automated":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_automated_message",
                    "",
                    "",
                    { dateLog }
                );
            case "default_confirm":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_message",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "approve":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_message",
                    "",
                    "",
                    { dateLog, performer: author }
                );
            case "default_confirm_during_approval_automated":
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "default_confirm_during_approval_automated_message",
                    "",
                    "",
                    { dateLog }
                );
            case "reject":
                let rejectReason = "";
                if (_.get(this.lastLog, "metadata.rejectReason", false)) {
                    rejectReason = " \"" + _.get(this.lastLog, "metadata.rejectReason", false) + " \"";
                }
                return _.invoke(
                    this.$options.filters,
                    "trans",
                    "reject_message",
                    "",
                    "",
                    { dateLog, performer: author }
                ) + rejectReason;
            default:
                return "";
        }
    }

    public closed() {
        this.$emit("closed");
    }
}

